import {
  UserInfoApi
} from './api'
import {
  UserLoginApi
} from './api'
// $UserInfoApiFn()  公用的Userinfo

export function UserInfoApiFn() {
  return new Promise(function (resolve, reject) {
    UserInfoApi({name:123123}).then(function(res){
      lycamWeb.clearCookie();
      if (res && res.data && res.code == 0) {
        resolve(res)
      }
    }).catch( function(err) {
      reject(err)
    })
  })
}
export function UserLoginApiFn() {
  return new Promise(function (resolve, reject) {
    UserLoginApi({
      Appid: 'wxb5a883c5bf26e000',
      Code: lycamWeb.parseQueryString(window.location.href).code,
    }).then(function(res) {
      resolve(res)
    }).catch(function(err) {
      reject(err)
    })
  })

}



// WEBPACK FOOTER //
// ./src/request/index.js